import PropTypes from 'prop-types';
import React from 'react';
import GoButton from '../components/GoButton';
import AudioContainer from '../audio/audioContainer';
import CommonLayout from '../layouts/commonLayout';

export default class OpeningView extends React.Component {
    componentDidMount() {
        this.props.narrateScreen();
    }

    componentWillUnmount() {
        this.props.cleanup();
    }

    render() {
        return (
            <CommonLayout class="assessment-directions">
                <AudioContainer />
                {this.props.isNextButtonActive && (
                    <GoButton onClick={this.props.onNext} isEnabled={!this.props.isScreenBlocked} />
                )}
            </CommonLayout>
        );
    }
}

OpeningView.propTypes = {
    narrateScreen: PropTypes.func.isRequired,
    onNext: PropTypes.func.isRequired,
    cleanup: PropTypes.func.isRequired,
    isNextButtonActive: PropTypes.bool,
    isScreenBlocked: PropTypes.bool,
};

OpeningView.defaultProps = {
    isNextButtonActive: false,
    isScreenBlocked: false,
};
